export default class TaxService {
    getTaxRateArr(invType) {
        /** 税率数组
        *    {taxText: '文本',
        *    taxRate: 0}
        * */
        const taxRateArr = [{
            taxText: '3%',
            taxRate: 0.03,
        }, {
            taxText: '4%',
            taxRate: 0.04,
        }, {
            taxText: '5%',
            taxRate: 0.05,
        }, {
            taxText: '6%',
            taxRate: 0.06,
        }, {
            taxText: '9%',
            taxRate: 0.09,
        }, {
            taxText: '10%',
            taxRate: 0.1,
        }, {
            taxText: '11%',
            taxRate: 0.11,
        }, {
            taxText: '13%',
            taxRate: 0.13,
        }, {
            taxText: '16%',
            taxRate: 0.16,
        }, {
            taxText: '17%',
            taxRate: 0.17,
        }]
        if (invType === '0') {
            taxRateArr.unshift({
                taxText: '减按1.5%计征',
                taxRate: 0.015,
            })
        } else if (invType === '51') {
            taxRateArr.unshift({
                taxText: '0%',
                taxRate: 0,
            })
        } else {
            taxRateArr.unshift({
                taxText: '减按1.5%计征',
                taxRate: 0.015,
            })
            taxRateArr.unshift({
                taxText: '0%',
                taxRate: 0,
            })
        }
        return taxRateArr
    }

    getTaxRateNumberArr() {
        return [0.03, 0.04, 0.05, 0.06, 0.09, 0.1, 0.11, 0.13, 0.16, 0.17]
    }
}



// WEBPACK FOOTER //
// ./src/common/services/TaxService.js